// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__QiWaH","validationTips":"StatementDescriptor_validationTips__17nc2"};